import { render, staticRenderFns } from "./FiltersModal.vue?vue&type=template&id=c0ea12c6&scoped=true"
import script from "./FiltersModal.vue?vue&type=script&lang=js"
export * from "./FiltersModal.vue?vue&type=script&lang=js"
import style0 from "./FiltersModal.vue?vue&type=style&index=0&id=c0ea12c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ea12c6",
  null
  
)

export default component.exports